import React, { useState } from 'react';
import DescriptionPopup from './DescriptionPopup';
type ProfileRowProps = {
    profile: any;
    ticker: string;
    symbolInfo : any
  };

const ProfileRow: React.FC<ProfileRowProps> = ({profile, ticker, symbolInfo}) => {

return (
      <div className="profile row">
                  <div className="column">
                    <h3>
                      {ticker}
                      {profile && profile.companyName && (
                        <span>
                          {' '}
                          {profile.companyName}
                          {profile && profile.website && (
                            <a href={profile.website}>
                              {' '}
                              {profile.website}
                            </a>
                          )}
                        </span>
                      )}
                    </h3>

                    {profile && profile.industry && (
                      <h4>
                        Industry: {profile.industry}
                        {profile && profile.sector && (
                          <span> Sector: {profile.sector}</span>
                        )}
                      </h4>
                    )}

                    {profile && profile.description && (
                      <DescriptionPopup
                        description={profile.description}
                      ></DescriptionPopup>
                    )}
                  </div>

                  <div className="column">
                    {profile && profile.marketCap && (
                      <h4>
                        {' '}
                        Market Cap:{' '}
                        {formatMarketCap(profile.marketCap)}
                      </h4>
                    )}

                    {profile && profile.volume && (
                      <h4>
                        Volume: {formatVolume(profile.volume)}
                        {profile && profile.averageVolume && (
                          <span>
                            {' '}
                            Avg. Volume:{' '}
                            {formatVolume(profile.averageVolume)}
                          </span>
                        )}
                        {profile.volumePercent && (
                          <h4>( {profile.volumePercent} X )</h4>
                        )}
                      </h4>
                    )}
                  </div>
                  <div className="column">
                    {profile && profile.country && (
                      <h4>
                        Country: {profile.country}
                        {profile.city && (
                          <span> {profile.city} </span>
                        )}
                        {profile.state && (
                          <span> {profile.state} </span>
                        )}
                      </h4>
                    )}

                    {profile && profile.fullTimeEmployees && (
                      <h4>
                        Full Time Employees:{' '}
                        {profile.fullTimeEmployees}
                      </h4>
                    )}

                    {symbolInfo && symbolInfo.atr && symbolInfo.rsRating && (
                      <div>
                      <h4> ATR 21day % :  {symbolInfo.atr}</h4>
                      <h4> RS :  {symbolInfo.rsRating}</h4>
                      </div>
                    )}
                  </div>
                </div>
)};

function formatVolume(value: number) {
    if (value >= 1_000_000_000) {
      return (value / 1_000_000_000).toFixed(2).replace(/\.00$/, '') + 'B';
    } else if (value >= 1_000_000) {
      return (value / 1_000_000).toFixed(2).replace(/\.00$/, '') + 'M';
    } else if (value >= 1_000) {
      return (value / 1_000).toFixed(2).replace(/\.00$/, '') + 'K';
    } else {
      return value.toString();
    }
  }

  function formatMarketCap(value: number): string {
    if (value >= 1_000_000_000_000) {
      return (value / 1_000_000_000_000).toFixed(2) + 'T';
    } else if (value >= 1_000_000_000) {
      return (value / 1_000_000_000).toFixed(2) + 'B';
    } else if (value >= 1_000_000) {
      return (value / 1_000_000).toFixed(2) + 'M';
    } else if (value >= 1_000) {
      return (value / 1_000).toFixed(2) + 'K';
    } else {
      return value.toString();
    }
  }


export default ProfileRow;